import TypeUtils from '@/helpers/type-utils';
import {AvailablePeriodType} from '@/data/models/enums/available-period-type';
import {MeterType} from "@/data/models/enums/meter-enum";

export default class GetTemperatureDataForm {
  startDate: Date;
  period: AvailablePeriodType;
  buildingId: string;
  type: MeterType;

  static map(data: Partial<GetTemperatureDataForm>): GetTemperatureDataForm {
    if (!data) {
      return null;
    }

    const statsForm: GetTemperatureDataForm = new GetTemperatureDataForm();

    statsForm.startDate = TypeUtils.hasDateOrDefault(data.startDate);
    statsForm.period = TypeUtils.hasEnumOrDefault(data.period, AvailablePeriodType);
    statsForm.buildingId = TypeUtils.hasStringOrDefault(data.buildingId, "");
    statsForm.type = TypeUtils.hasEnumOrDefault(data.type, MeterType, MeterType.TEMPERATURE);

    return statsForm;
  }

  toJSON(): { startDate: Date; period: AvailablePeriodType; type: MeterType; buildingId: string } {
    return {
      'startDate': this.startDate,
      'period': this.period,
      'type': this.type,
      'buildingId': this.buildingId || null
    };
  }
}
